import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useEquipmentResourceStore } from '~/client/src/shared/hooks/useEquipmentResourceStore'
import { useResourceRuntimeContext } from '~/client/src/shared/hooks/useResourceRuntimeContext'

import { createResourceProvider } from '../../components/Resource/createResourceProvider'

export const EquipmentProvider = createResourceProvider({
  resourceTypeId: ResourceTypeId.OFFLOADING_EQUIPMENT,
  useSource: useEquipmentResourceStore,
  columnConfigKey: LocalStorageKey.EquipmentColumnConfig,
  useRuntimeContext: useResourceRuntimeContext,
})
